import React from 'react'
import PropTypes from 'prop-types'
import Layout from '../components/layout'
import StructuredData from "../components/structured-data";
import SeoTags from '../components/seo-tags'
import {withRouter} from 'react-router-dom';
import Breadcrumbs from "../components/breadcrumbs/breadcrumbs";

const AmazonAffiliatePage = ({ data, location }) => {
  const { markdownRemark: post } = data
  const title = post.frontmatter.title
  const seo = post.frontmatter.seo
  const html = post.html

  return (
    <Layout>
      <StructuredData isReview={false} isBreadcrumbs={true} title={title} pagePath={location.pathname}/>
      <SeoTags
        title={`${seo.title}`}
        description={`${seo.description}`}
      />
      <Breadcrumbs currentPage={title} />
      <div className="amazon-affiliate">
        <div className="amazon-affiliate__wrapper">
          <h1 className="amazon-affiliate__title" id={title}>{title}</h1>
          <div className="amazon-affiliate__text" dangerouslySetInnerHTML={{ __html: html }} />
        </div>
      </div>
    </Layout>
  )
}

AmazonAffiliatePage.propTypes = {
  data: PropTypes.object.isRequired,
};

export default withRouter(AmazonAffiliatePage);

export const CamazonAffiliatePageQuery = graphql`
  query AmazonAffiliatePage($id: String!) {
    markdownRemark(id: { eq: $id }) {
      html
      frontmatter {
        title
        seo {
          title
          description
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/templates/amazon-affiliate.js